var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { requestNcodeArray_UserCredential } from "../../../ncodepod/PaperHubClient/NcodedDocGenerator/requestNcode";
/**
   *  이 함수가 불려지기 전에, printOption에는 다음과 같은 항목이 설정되어 있어야만 한다.
   * * url, filename, fingerprint, pagesperSheet, docNumPages
   *
   * 이 리턴 값은 printOption으로 바로 들어가서 대체될 수 있다.
   * * printOption = {...printOption, ...returnValue }
   * * 또는, for (const key in returnValue) printOption[key] = returnValue[key];
   */
export function getUniqueNcode(printOption) {
    return __awaiter(this, void 0, void 0, function* () {
        const { docNumPages, mediaSize } = printOption;
        // const uniqueCodeInfo = await requestNcodeArray_AppCredential(docNumPages, mediaSize);
        const uniqueCodeInfo = yield requestNcodeArray_UserCredential(docNumPages, mediaSize);
        const ret = {
            baseSobp: uniqueCodeInfo.sobp_and_urls ? uniqueCodeInfo.sobp_and_urls[0].sobp : undefined,
            sobp_and_urls: uniqueCodeInfo.sobp_and_urls,
        };
        return ret;
    });
}
export function getUniqueNcode_old(printOption) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { docNumPages, mediaSize } = printOption;
        // const uniqueCodeInfo = await requestNcodeArray_AppCredential(docNumPages, mediaSize);
        const uniqueCodeInfo = yield requestNcodeArray_UserCredential(docNumPages, mediaSize);
        const ret = {
            baseSobp: uniqueCodeInfo.sobp_and_urls ? uniqueCodeInfo.sobp_and_urls[0].sobp : undefined,
            ncodeUrls: (_a = uniqueCodeInfo.sobp_and_urls) === null || _a === void 0 ? void 0 : _a.map(item => item.url),
            sobps: (_b = uniqueCodeInfo.sobp_and_urls) === null || _b === void 0 ? void 0 : _b.map(item => item.sobp), //niqueCodeInfo.sobps,
        };
        return ret;
    });
}
//# sourceMappingURL=getIssuedCode.js.map